export class MoneyService {
  public roundToCents(value: number) {
    if (!Number.isFinite(value)) return 0;

    const cents = value * 100;

    return Math.round(cents + Math.sign(cents) * 1e-9) / 100;
  }

  public formatUsd(value: number) {
    const formatter = new Intl.NumberFormat('en-US', {
      currency: 'USD',
      style: 'currency',
      signDisplay: 'auto',
    });

    return formatter.format(value);
  }
}

export const moneyService = new MoneyService();
